import Svg from '../generated/DesignElementWh4';
import { Icon, type IconProps } from './Icon';

export const DesignElementWh4Icon = (props: IconProps) => (
    <Icon component={Svg} name="designElementWh4" inheritColors={false} {...props} />
);
